// AI Generated Component
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { AccPdfAccessibilityRemediationService } from './remediation.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

@Component({
    selector: 'acc-doc-pdf-accessibility-remediation-btn',
    standalone: false,
    template: `
        <button class="acc-doc-pdf-accessibility-remediation-btn btn-border-radius btn btn-border-radius btn-secondary"
            *ngIf="pdf.clarity_remediated && hasAccess()" [ngClass]="{'mon-disabled': pdf.clarity_remediated}"
            (click)="confirmation()" [title]="'Remediation' | translate"
            [attr.aria-label]="'Remediation quote has been requested' | translate"
            [triggers]="'focus hover'"
            [ngbTooltip]="'Remediation quote has been requested' | translate"
            translate>
            Remediation quote
        </button>
        <button class="acc-doc-pdf-accessibility-remediation-btn btn-border-radius btn btn-border-radius btn-secondary"
            monEventTrigger="actionTrigger" [monEventParams]="{action:'accessibility-remediation'}"
            *ngIf="!pdf.clarity_remediated && hasAccess()" (click)="confirmation()"
            [title]="'Remediation' | translate" translate>
            Remediation quote
        </button>
    `,
})
export class AccDocPdfAccessibilityRemediationBtnComponent {
    @Input() pdf: any;
    @Output() afterResolve: EventEmitter<any> = new EventEmitter<any>();
    @Output() afterError: EventEmitter<any> = new EventEmitter<any>();

    constructor (
        private sessionService: SessionService,
        private accPdfAccessibilityRemediationService: AccPdfAccessibilityRemediationService,
        private monEventService: MonEventService,
    ) {}

    hasAccess (): boolean {
        return Boolean(this.sessionService.customer && this.sessionService.customer.plan_traits.clarity_pdf_remediation);
    }

    confirmation (): void {
        if (this.pdf.clarity_remediated) {
            return;
        }
        this.monEventService.run('remediationBtnClick', { url: this.pdf.url, title: this.pdf.title });
        this.accPdfAccessibilityRemediationService.createRemediationDialog(() => {
            this.accPdfAccessibilityRemediationService.createRemediation(this.pdf).then(
                (data) => {
                    this.monEventService.run('actionTrigger', { action: 'accessibility-remediation-confirm' });
                    this.afterResolve.emit(data);
                },
                (resp) => {
                    this.afterError.emit(resp);
                },
            );
        });
    }
}
